import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Typography
} from '@material-ui/core';

import AccountsDisplay from 'components/Accounts/AccountsDisplay';

const SelectUser = ({userIsAdmin, ...props}) => {

  const [openAccountsDisplay, setOpenAccountsDisplay] = useState(false);
  const [currentUserId, setCurrentUserId] = useState("");

  const showAccountsDisplay = (userId) => {
    if(userIsAdmin) setCurrentUserId(userId);
    setOpenAccountsDisplay(true);
  };

  const hideAccountsDisplay = () => {
    setCurrentUserId("");
    setOpenAccountsDisplay(false);
  };

  return (
    <Box>
      { openAccountsDisplay ?
        ( userIsAdmin ?
        <AccountsDisplay
          salesOrders={props.salesOrders.filter(salesOrder => salesOrder.userId === currentUserId)}
          purchaseOrders={props.purchaseOrders}
          returnOrders={props.returnOrders}
          expenses={props.expenses.filter(expense => expense.userId === currentUserId)}
          products={props.products}
          customers={props.customers}
          vendors={props.vendors}
          user={props.user}
          hideAccountsDisplay={hideAccountsDisplay}
        /> :
        <AccountsDisplay
          salesOrders={props.salesOrders}
          purchaseOrders={props.purchaseOrders}
          returnOrders={props.returnOrders}
          expenses={props.expenses}
          products={props.products}
          customers={props.customers}
          vendors={props.vendors}
          user={props.user}
          hideAccountsDisplay={hideAccountsDisplay}
        />
        ) :
        ( userIsAdmin ?
          <Box>
            <Typography
              color="textPrimary"
              variant="h4"
            >
              Pick a user:
            </Typography>
            <ButtonGroup color="primary" aria-label="text primary button group">
              { props.user.standard_users.map(user => (
                <Button
                  key={user.id}
                  onClick={showAccountsDisplay.bind(this, user.id)}
                >
                  {user.name}
                </Button>
              )) }
            </ButtonGroup>
          </Box> :
          <Box>
            <Typography
              color="textPrimary"
              variant="h4"
            >
              Show Accounts:
            </Typography>
            <ButtonGroup color="primary" aria-label="text primary button group">
              <Button
                  onClick={showAccountsDisplay}
                >
                  {props.user.name}
              </Button>
            </ButtonGroup>
          </Box>
        )
      }
    </Box>
  )
};

export default SelectUser;